import { mockSuccess, listPayload } from './shared';
import type { MockRouteEntry } from '../mock-api.types';

let DMS_SETTINGS = {
    storage_root: '/outbox/_company',
    default_template_pack: 'standard-2026',
    ai_draft_enabled: true,
    nextcloud_sync: true,
    max_file_size_mb: 20,
    external_link_expiry_days: 14,
    external_link_password_required: false,
    allow_self_approve: false,
    retention_years: 7,
    esign_provider: 'DocuSign (mock)',
};

const FILES = [
    { id: 'file-1', name: 'Board pack Q2.pdf', folder_id: '_finance', mime_type: 'application/pdf', size_bytes: 2450000, nextcloud_path: '/outbox/_finance/board/q2-2026.pdf', download_url: 'https://example.com/mock.pdf', is_document_link: true, document_id: 'doc-4', visibility: 'org_public', updated_at: '2026-05-28T08:00:00Z' },
    { id: 'file-2', name: 'Employee handbook.pdf', folder_id: '_hr', mime_type: 'application/pdf', size_bytes: 890000, nextcloud_path: '/outbox/_hr/policies/handbook.pdf', download_url: 'https://example.com/mock.pdf', visibility: 'branch_public', updated_at: '2026-06-01T10:00:00Z' },
    { id: 'file-3', name: 'Logo assets.zip', folder_id: '_company', mime_type: 'application/zip', size_bytes: 12000000, nextcloud_path: '/outbox/_company/branding/logo-pack.zip', download_url: 'https://example.com/mock.zip', visibility: 'org_public', updated_at: '2026-06-04T09:00:00Z' },
    { id: 'file-4', name: 'Site photo.jpg', folder_id: '_projects', mime_type: 'image/jpeg', size_bytes: 2400000, nextcloud_path: '/outbox/_projects/site-photo.jpg', download_url: 'https://example.com/mock.jpg', visibility: 'private', updated_at: '2026-06-04T11:00:00Z' },
    { id: 'file-5', name: 'Promo reel.mp4', folder_id: '_shared', mime_type: 'video/mp4', size_bytes: 18000000, nextcloud_path: '/outbox/_shared/promo.mp4', download_url: 'https://example.com/mock.mp4', visibility: 'shared', updated_at: '2026-06-02T14:00:00Z' },
];

const DOCS = [
    {
        id: 'doc-1',
        title: 'Employment contract — Jane Doe',
        status: 'review',
        visibility: 'private',
        folder_id: '_hr',
        category: 'Contract',
        summary: 'Awaiting supervisor approval.',
        file_type: 'pdf',
        version: 2,
        template_id: 'tpl-1',
        template_name: 'Employment contract',
        letterhead_id: 'lh-1',
        letterhead_name: 'Outbox corporate uniform',
        employee_id: 'emp-101',
        employee_name: 'Jane Doe',
        supervisor_name: 'Alex Manager',
        self_approve_allowed: false,
        external_link_active: false,
        content_html: '<h2>Employment contract</h2><p>Jane Doe — Senior Analyst.</p>',
        updated_at: '2026-06-04T12:00:00Z',
        created_at: '2026-06-01T09:00:00Z',
        nextcloud_path: '/outbox/_hr/emp-101/contract-draft.pdf',
        shared_with: ['hr@services.ashcorp.co'],
        versions: [
            { version: 2, label: 'Supervisor edits', updated_at: '2026-06-04T12:00:00Z', author: 'hr@services.ashcorp.co', status: 'review' },
            { version: 1, label: 'HR draft', updated_at: '2026-06-01T09:00:00Z', author: 'hr@services.ashcorp.co', status: 'draft' },
        ],
    },
    {
        id: 'doc-2',
        title: 'NDA — Vendor ACME',
        status: 'signed',
        visibility: 'branch_public',
        folder_id: '_legal',
        category: 'NDA',
        summary: 'Locked after e-sign.',
        file_type: 'pdf',
        version: 1,
        content_html: '<h2>NDA</h2><p>Signed via provider.</p>',
        updated_at: '2026-06-03T12:00:00Z',
        created_at: '2026-06-03T12:00:00Z',
        nextcloud_path: '/outbox/_legal/vendors/acme-nda.pdf',
        external_link_active: false,
        versions: [{ version: 1, label: 'Executed', updated_at: '2026-06-03T12:00:00Z', author: 'admin@services.ashcorp.co', status: 'signed' }],
    },
    {
        id: 'doc-3',
        title: 'Warning letter — attendance',
        status: 'final',
        visibility: 'private',
        folder_id: '_hr',
        category: 'Warning letter',
        summary: 'Ready for physical sign or digital send.',
        file_type: 'pdf',
        version: 1,
        employee_name: 'Alex Rivera',
        supervisor_name: 'Alex Manager',
        letterhead_id: 'lh-2',
        letterhead_name: 'Contract first page',
        content_html: '<h2>Warning letter</h2><p>Policy section 4.2.</p>',
        updated_at: '2026-06-02T15:30:00Z',
        created_at: '2026-06-02T15:30:00Z',
        nextcloud_path: '/outbox/_hr/emp-204/documents/warnings/warn-2026-06.pdf',
    },
    {
        id: 'doc-4',
        title: 'Q2 board pack',
        status: 'signed',
        visibility: 'org_public',
        folder_id: '_finance',
        category: 'Report',
        summary: 'Organization-wide pack.',
        file_type: 'pdf',
        version: 3,
        content_html: '<h2>Board pack Q2</h2>',
        updated_at: '2026-05-28T08:00:00Z',
        created_at: '2026-05-20T08:00:00Z',
        nextcloud_path: '/outbox/_finance/board/q2-2026.pdf',
    },
    {
        id: 'doc-5',
        title: 'Offer letter — Sam Patel',
        status: 'draft',
        visibility: 'private',
        folder_id: '_hr',
        category: 'Offer',
        summary: 'AI-filled draft; not yet submitted.',
        file_type: 'html',
        version: 1,
        template_id: 'tpl-1',
        template_name: 'Employment contract',
        content_html: '<h2>Offer letter</h2><p>DevOps Engineer.</p>',
        updated_at: '2026-06-04T09:15:00Z',
        created_at: '2026-06-04T09:15:00Z',
        nextcloud_path: null,
    },
];

const TEMPLATES = [
    {
        id: 'tpl-1',
        name: 'Employment contract',
        description: 'Standard full-time employment agreement.',
        kind: 'contract',
        content_html: '<h2>Employment agreement</h2><p>{{employee_name}} — {{start_date}}</p>',
        variables: ['employee_name', 'start_date', 'role_title', 'salary'],
        allowed_roles: ['hr_manager', 'document_author'],
        default_letterhead_id: 'lh-1',
        default_letterhead_name: 'Outbox corporate uniform',
        updated_at: '2026-06-04T12:00:00Z',
    },
    {
        id: 'tpl-2',
        name: 'NDA (mutual)',
        description: 'Vendor and partner NDAs.',
        kind: 'contract',
        content_html: '<h2>NDA</h2><p>{{party_name}}</p>',
        variables: ['party_name', 'term_years'],
        allowed_roles: ['legal', 'document_author', 'branch_admin'],
        default_letterhead_id: 'lh-1',
        default_letterhead_name: 'Outbox corporate uniform',
        updated_at: '2026-06-04T12:00:00Z',
    },
    {
        id: 'tpl-3',
        name: 'Warning letter — attendance',
        description: 'HR warning with policy refs.',
        kind: 'letter',
        content_html: '<h2>Warning</h2><p>{{employee_name}}</p>',
        variables: ['employee_name', 'incident_date', 'policy_section'],
        allowed_roles: ['hr_manager'],
        default_letterhead_id: 'lh-2',
        default_letterhead_name: 'Contract first page',
        updated_at: '2026-06-03T10:00:00Z',
    },
];

const CONTRACTS = [
    { id: 'doc-7', title: 'Contract from template — John', status: 'draft', visibility: 'private', folder_id: '_hr', content_html: '<p></p>', updated_at: '2026-06-04T12:00:00Z', created_at: '2026-06-04T12:00:00Z', nextcloud_path: null },
];

const LETTERHEADS = [
    { id: 'lh-1', name: 'Outbox corporate uniform', description: 'Logo header + footer on all pages', scope: 'uniform', status: 'active', preview_url: 'https://example.com/letterhead-uniform.pdf', updated_at: '2026-06-04T10:00:00Z' },
    { id: 'lh-2', name: 'Contract first page', description: 'Heavy branding on page 1 only', scope: 'first_page', status: 'active', preview_url: 'https://example.com/letterhead-first.pdf', updated_at: '2026-06-03T10:00:00Z' },
];

function findDoc(url: string) {
    const m = url.match(/\/documents\/([^/?]+)/i);
    return m ? DOCS.find((r) => r.id === m[1]) : undefined;
}

function findTemplate(url: string) {
    const m = url.match(/\/templates\/([^/?]+)/i);
    return m ? TEMPLATES.find((r) => r.id === m[1]) : undefined;
}

function findLetterhead(url: string) {
    const m = url.match(/\/letterheads\/([^/?]+)/i);
    if (!m || m[1] === 'new') return undefined;
    return LETTERHEADS.find((r) => r.id === m[1]);
}


const BROWSE_ROOT: Array<{ id: string; name: string; path: string; size_bytes: number; updated_at: string }> = [
    { id: 'fld-admin', name: 'admin', path: 'admin', size_bytes: 31457280, updated_at: '2026-06-04T10:00:00Z' },
    { id: 'fld-archive', name: 'archive', path: 'archive', size_bytes: 52428800, updated_at: '2026-05-20T08:00:00Z' },
    { id: 'fld-talk', name: 'Talk', path: 'Talk', size_bytes: 12582912, updated_at: '2026-06-03T14:00:00Z' },
    { id: 'fld-api', name: 'xyz.ashcorp.api', path: 'xyz.ashcorp.api', size_bytes: 31876710, updated_at: '2026-06-04T09:00:00Z' },
];

const BROWSE_LABELS: Record<string, string> = {
    '': 'Personal Files',
    admin: 'admin',
    archive: 'archive',
    Talk: 'Talk',
    'xyz.ashcorp.api': 'xyz.ashcorp.api',
    _company: 'Company',
    _hr: 'Human resources',
    _legal: 'Legal',
    _finance: 'Finance',
    _projects: 'Projects',
    _shared: 'Shared',
};

function browsePath(url: string): string {
    const u = new URL(url, 'http://local');
    return u.searchParams.get('path') || '';
}

function buildBrowse(path: string) {
    const parent = path.includes('/') ? path.split('/').slice(0, -1).join('/') : '';
    const parent_path = path ? (parent || null) : null;
    if (!path) {
        const items = BROWSE_ROOT.map((f) => ({
            id: f.id,
            kind: 'folder' as const,
            name: f.name,
            path: f.path,
            size_bytes: f.size_bytes,
            updated_at: f.updated_at,
        }));
        const total = items.reduce((s, i) => s + (i.size_bytes || 0), 0);
        return {
            path: '',
            label: BROWSE_LABELS[''],
            parent_path: null,
            items,
            folder_count: items.length,
            file_count: 0,
            total_size_bytes: total,
        };
    }
    const taxonomy = ['_company', '_hr', '_legal', '_finance', '_projects', '_shared'];
    if (taxonomy.includes(path)) {
        const items = FILES.filter((f) => f.folder_id === path).map((f) => ({
            id: f.id,
            kind: 'file' as const,
            name: f.name,
            path: `${path}/${f.name}`,
            size_bytes: f.size_bytes,
            updated_at: f.updated_at,
            mime_type: f.mime_type,
            download_url: f.download_url,
            is_document_link: f.is_document_link,
            document_id: f.document_id,
        }));
        const total = items.reduce((s, i) => s + (i.size_bytes || 0), 0);
        return {
            path,
            label: BROWSE_LABELS[path] || path,
            parent_path: '',
            items,
            folder_count: 0,
            file_count: items.length,
            total_size_bytes: total,
        };
    }
    const root = BROWSE_ROOT.find((f) => f.path === path);
    if (root) {
        const subfolders = taxonomy.map((tid) => {
            const size = FILES.filter((f) => f.folder_id === tid).reduce((s, f) => s + f.size_bytes, 0);
            return {
                id: `sub-${tid}`,
                kind: 'folder' as const,
                name: (BROWSE_LABELS[tid] || tid).replace(/^_/, ''),
                path: tid,
                size_bytes: size,
                updated_at: '2026-06-04T12:00:00Z',
            };
        });
        const total = subfolders.reduce((s, i) => s + (i.size_bytes || 0), 0);
        return {
            path,
            label: root.name,
            parent_path: '',
            items: subfolders,
            folder_count: subfolders.length,
            file_count: 0,
            total_size_bytes: total,
        };
    }
    return { path, label: path, parent_path: '', items: [], folder_count: 0, file_count: 0, total_size_bytes: 0 };
}


export const DMS_MOCK_HANDLERS: MockRouteEntry[] = [
    { method: 'GET', pattern: /\/api\/[^/]+\/[^/]+\/dms\/settings/i, handler: () => mockSuccess(DMS_SETTINGS) },
    { method: 'PATCH', pattern: /\/api\/[^/]+\/[^/]+\/dms\/settings/i, handler: (req) => { DMS_SETTINGS = { ...DMS_SETTINGS, ...(req.body as object) }; return mockSuccess(DMS_SETTINGS); } },
    { method: 'GET', pattern: /\/api\/[^/]+\/[^/]+\/dms\/browse/i, handler: (req) => mockSuccess(buildBrowse(browsePath(req.url))) },
    { method: 'GET', pattern: /\/api\/[^/]+\/[^/]+\/dms\/files(\?|$)/i, handler: () => mockSuccess(listPayload(FILES)) },
    { method: 'GET', pattern: /\/api\/[^/]+\/[^/]+\/dms\/documents(\?|$)/i, handler: () => mockSuccess(listPayload(DOCS)) },
    { method: 'GET', pattern: /\/api\/[^/]+\/[^/]+\/dms\/documents\/[^/?]+/i, handler: (req) => mockSuccess(findDoc(req.url) ?? DOCS[0]) },
    {
        method: 'PATCH',
        pattern: /\/api\/[^/]+\/[^/]+\/dms\/documents\/[^/?]+/i,
        handler: (req) => {
            const row = findDoc(req.url);
            if (row) Object.assign(row, req.body as object);
            return mockSuccess(row ?? DOCS[0]);
        },
    },
    {
        method: 'POST',
        pattern: /\/api\/[^/]+\/[^/]+\/dms\/documents\/[^/]+\/status/i,
        handler: (req) => {
            const row = findDoc(req.url);
            const body = (req.body || {}) as { status?: string };
            if (row && body.status) row.status = body.status as typeof row.status;
            return mockSuccess(row ?? DOCS[0], 'Status updated (mock)');
        },
    },
    {
        method: 'POST',
        pattern: /\/api\/[^/]+\/[^/]+\/dms\/documents\/[^/]+\/sign\/digital/i,
        handler: (req) => mockSuccess({ provider_url: 'https://example.com/esign-mock' }, 'Sent to e-sign provider (mock)'),
    },
    {
        method: 'POST',
        pattern: /\/api\/[^/]+\/[^/]+\/dms\/documents\/[^/]+\/sign\/physical/i,
        handler: (req) => {
            const row = findDoc(req.url);
            if (row) row.status = 'signed';
            return mockSuccess(row ?? DOCS[0], 'Signed copy uploaded (mock)');
        },
    },
    {
        method: 'POST',
        pattern: /\/api\/[^/]+\/[^/]+\/dms\/documents\/[^/]+\/external-link/i,
        handler: (req) => {
            const row = findDoc(req.url);
            if (row) row.external_link_active = true;
            return mockSuccess({ url: 'https://example.com/external/doc-mock', expires_at: '2026-06-18T00:00:00Z' });
        },
    },
    {
        method: 'DELETE',
        pattern: /\/api\/[^/]+\/[^/]+\/dms\/documents\/[^/]+\/external-link/i,
        handler: (req) => {
            const row = findDoc(req.url);
            if (row) row.external_link_active = false;
            return mockSuccess(row ?? DOCS[0], 'Link revoked (mock)');
        },
    },
    {
        method: 'POST',
        pattern: /\/api\/[^/]+\/[^/]+\/dms\/branch-transfer/i,
        handler: () => mockSuccess({ transferred: 2, shared: 1 }, 'Branch transfer applied (mock)'),
    },
    { method: 'GET', pattern: /\/api\/[^/]+\/[^/]+\/dms\/templates(\?|$)/i, handler: () => mockSuccess(listPayload(TEMPLATES)) },
    { method: 'GET', pattern: /\/api\/[^/]+\/[^/]+\/dms\/templates\/[^/?]+/i, handler: (req) => mockSuccess(findTemplate(req.url) ?? TEMPLATES[0]) },
    { method: 'GET', pattern: /\/api\/[^/]+\/[^/]+\/dms\/contracts(\?|$)/i, handler: () => mockSuccess(listPayload(CONTRACTS)) },
    { method: 'GET', pattern: /\/api\/[^/]+\/[^/]+\/dms\/letterheads(\?|$)/i, handler: () => mockSuccess(listPayload(LETTERHEADS)) },
    { method: 'GET', pattern: /\/api\/[^/]+\/[^/]+\/dms\/letterheads\/[^/?]+/i, handler: (req) => mockSuccess(findLetterhead(req.url) ?? LETTERHEADS[0]) },
    { method: 'POST', pattern: /\/api\/[^/]+\/[^/]+\/dms\/letterheads(\?|$)/i, handler: (req) => {
        const body = (req.body || {}) as Record<string, string>;
        const next = { id: `lh-${LETTERHEADS.length + 1}`, name: body['name'] || 'New letterhead', description: body['description'] || '', scope: (body['scope'] as 'uniform') || 'uniform', status: 'active', preview_url: 'https://example.com/letterhead-new.pdf', updated_at: new Date().toISOString() };
        LETTERHEADS.push(next);
        return mockSuccess(next);
    }},
    { method: 'PATCH', pattern: /\/api\/[^/]+\/[^/]+\/dms\/letterheads\/[^/?]+/i, handler: (req) => {
        const row = findLetterhead(req.url);
        if (row) Object.assign(row, req.body as object);
        return mockSuccess(row ?? LETTERHEADS[0]);
    }},
    { method: 'POST', pattern: /\/api\/[^/]+\/[^/]+\/dms\/contracts(\?|$)/i, handler: () => mockSuccess({ ...DOCS[0], id: 'doc-new', title: 'New contract', status: 'draft', visibility: 'private' }) },
    { method: 'POST', pattern: /\/api\/[^/]+\/[^/]+\/dms\/documents\/[^/]+\/pdf/i, handler: () => mockSuccess({ url: 'https://example.com/mock.pdf', nextcloud_path: '/mock/doc.pdf' }) },
];
